// ============================================
// AD HOC FEE HOOKS
// Combines hooks from:
// - [RecommendAdHocFee.tsx] RecommendAdHocFee (top-level) (ADHOC FEES 3350-3351)
// ============================================

import {AutoFieldHelpers} from '../../../components/AutoForm/useAutoForm';
import {recommendFieldsType} from '../CreateRecommend/recommendFields';
import {adHocFeeFieldType} from '../RecommendAdHocFee/adHocFeeFields';
import {OVRecommendation} from '../../../schema-types/OVRecommendation';
import FREQUENCY from '../../../constants/Frequency';
import {initialAdHocFee} from '../RecommendAdHocFee/RecommendAdHocFields';
import {UPDATES} from '../../../shared/UPDATES';
import {AdhocFeeTypeEnum} from '../../../schema-types/globalTypes';

export const loadSavedAdHocFee = ({
  recommendDetails,
  adhocHelpers,
}: {
  recommendDetails: OVRecommendation | null;
  adhocHelpers: AutoFieldHelpers<adHocFeeFieldType | undefined>;
}) => {
  if (!recommendDetails) {
    // if no data, just use the initial one
    adhocHelpers.setValue(UPDATES._3350, initialAdHocFee);
    return;
  }
  const savedSource = recommendDetails?.pots?.find((p) => p?.planType === 'source');
  // sometimes the crystallised ammount will be on the parent pot, so we check it too
  const parentSource = recommendDetails?.pots?.find(
    (p) => p?.id === savedSource?.pot?.parent?.id
  );
  const isMonetary = savedSource?.adhocFeeType === '£';

  const savedAdHocFee: recommendFieldsType['adHocFee'] = {
    feeType: isMonetary ? AdhocFeeTypeEnum.GBP : AdhocFeeTypeEnum.PERCENT,
    frequency: FREQUENCY.SINGLE,
    // instructionDate: savedSource?.adhocFeeDate,
    monetaryFee: isMonetary ? Number(savedSource?.adhocFeeAmount) : 0,
    percentFee: isMonetary ? 0 : Number(savedSource?.adhocFeeAmount),
    planId: savedSource?.pot?.id,
    crystallised: !Number(savedSource?.pot?.crystallisedFunds)
      ? parentSource?.pot?.crystallisedFunds
      : savedSource?.pot?.crystallisedFunds,
    uncrystallised: !Number(savedSource?.pot?.uncrystallisedFunds)
      ? parentSource?.pot?.uncrystallisedFunds
      : savedSource?.pot?.uncrystallisedFunds,
    reason: savedSource?.adhocFeeReason ?? undefined,
    planValue: savedSource?.pot?.totalValue,
  };
  adhocHelpers.setValue(UPDATES._3351, savedAdHocFee, true);
};
